import React from 'react';
import PropTypes from 'prop-types';
import AutoCompleteField from 'components/list/Filters/types/autocomplete/AutoCompleteField';
import compose from 'recompose/compose';
import utils from 'helpers/utils';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import { fetchPropertygroups } from 'store/actions/propertygroups/fetchPropertygroups';

class RenderPropertyGroupsInputField extends React.Component {
    componentDidMount() {
        const {
            fetch,
        } = this.props;

        // Fetch all the available property groups.
        fetch({
            size: 96,
            offset: 0,
            sort: {
                field: 'name',
                order: 'asc',
            },
        });
    }

    handleInputUpdate = utils.debounce((searchText, dataSource, params) => {
        // If the string of the source is not 'change' it will not continue.
        if (params.source !== 'change') {
            return;
        }

        // Remove whitespaces around the text.
        if (utils.isString(searchText)) {
            searchText.trim();
        }

        // Check if the searchText already exists in the dataSource.
        const textExists = dataSource.filter(function (data) {
            return data.text === searchText;
        });

        // If the length of the array > 0, it will not continue.
        if (textExists.length) {
            return;
        }
    }, 800);

    render() {
        const {
            choices,
            input,
            label,
        } = this.props;

        return (
            <Field
                component={ AutoCompleteField }
                choices={ choices }
                floatingLabelFixed={ false }
                fullWidth={ true }
                input={ input }
                onInputUpdate={ this.handleInputUpdate }
                label={ label ? label : null }
                name={ input.name }
                optionText='name'
                optionValue='id'
            />
        );
    }
}

RenderPropertyGroupsInputField.propTypes = {
    choices: PropTypes.array,
    fetch: PropTypes.func.isRequired,
    input: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func,
        onChange: PropTypes.func,
        value: PropTypes.value,
    }),
    label: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        choices: Object.values(state.propertygroups.data),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch: (params) => {
            dispatch(fetchPropertygroups(params));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )
);

export default enhance(RenderPropertyGroupsInputField);



// WEBPACK FOOTER //
// ./src/components/form/InputFields/AutoCompleteField/RenderPropertyGroupsInputField.js